'use strict';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Status, fetchInitialState } from './cfs-hub-slice';
import { LocationFilter } from './cfs-hub-filters/location-filter.jsx';
import { PriceFilter } from './cfs-hub-filters/price-filter.jsx';
import { TaxonomyFilter } from './cfs-hub-filters/taxonomy-filter.jsx';

export const Filters = ({ initialState, filterContext }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchInitialState(initialState));
	}, []);

	const totalResultCount = useSelector((state) => state.cfsHubSearch.filterState.totalResultCount);
	const resultsUrl = useSelector((state) => state.cfsHubSearch.filterState.resultsUrl);
	const filterStatus = useSelector((state) => state.cfsHubSearch.filterStatus);

	let sectionClassName = 'cfs-hub-filters';

	if (filterStatus === Status.Uninitialised || filterStatus === Status.Loading) {
		sectionClassName += ' cfs-hub-filters--loading';
	}

	const filterData = {
		range: {
			name: 'range',
			label: 'Model', // Range displays as Model in UI
			items: useSelector((state) => state.cfsHubSearch.filterState.rangeItems),
			navigated: useSelector((state) => state.cfsHubSearch.filterState.navigatedRange)
		},
		model: {
			name: 'model',
			label: 'Variant', // Model displays as Variant in UI
			items: useSelector((state) => state.cfsHubSearch.filterState.modelItems),
			navigated: useSelector((state) => state.cfsHubSearch.filterState.navigatedModel)
		},
	};

	const getTaxonomyFilter = () => {
		if (filterContext == 'Manufacturer') {
			return (
				<TaxonomyFilter
					filterItems={filterData.range.items}
					navigatedItem={filterData.range.navigated}
					filterName={filterData.range.name}
					label={filterData.range.label}
				/>
			);
		} else if (filterContext == 'Range') {
			return (
				<TaxonomyFilter
					filterItems={filterData.model.items}
					navigatedItem={filterData.model.navigated}
					filterName={filterData.model.name}
					label={filterData.model.label}
				/>
			);
		} else {
			return null;
		}
	};

	const getResultLink = () => {
		let buttonText = 'Loading...';
		if (totalResultCount >= 0) {
			buttonText = `View ${totalResultCount?.toLocaleString('en-GB')} used cars for sale`;
		}

		return (
			<a className="button cfs-hub-filters__result-link" href={resultsUrl}>{buttonText}</a>
		);
	};

	const taxonomyFilter = getTaxonomyFilter();
	const resultLink = getResultLink();

	return (
		<section className={sectionClassName}>
			<div className="cfs-hub-filters__filters-container">
				<LocationFilter />
				{taxonomyFilter}
				<PriceFilter />
				{resultLink}
			</div>
		</section>
	);
}